import React, { FC, useState, ReactNode } from 'react'
import classNames from 'classnames'
import { Box, Grid, Typography } from 'transfix-ui/core'
import { Button, calcGrid } from 'transfix-ui'
import { DEVICE_INFO } from 'constants/deviceInfo'

interface IDesktopReminderModalProps
  extends Pick<IDesktopReminderProps, 'message' | 'illustration'> {
  isOpen: boolean
  onClose: () => void
}

const DesktopReminderModal: FC<IDesktopReminderModalProps> = ({
  illustration,
  isOpen,
  message,
  onClose,
}) => {
  const className = classNames(
    isOpen ? 'flex' : 'dn',
    'full-screen flex-column justify-center items-center bg-default'
  )
  return (
    <div className={className}>
      {illustration && (
        <Grid item xs={10}>
          {illustration}
        </Grid>
      )}
      <Box textAlign='center' width={calcGrid(10)}>
        <Box mt={5}>
          <Typography variant='h2' component='div'>
            {message}
          </Typography>
        </Box>
        <div className='mt4 body-medium'>For the best experience, use a desktop browser.</div>
      </Box>
      <Box mt={5} width={calcGrid(4)}>
        <Button color='primary' fullWidth data-test='dismiss-action' size='large' onClick={onClose}>
          Dismiss
        </Button>
      </Box>
    </div>
  )
}

export interface IDesktopReminderProps {
  message: string
  illustration?: ReactNode
}
// A reuseable full page overlay component that automatically opens on mobile devices.
export const DesktopReminder: FC<IDesktopReminderProps> = ({ illustration, message }) => {
  const [isDeskstopReminderOpen, setIsDeskstopReminderOpen] = useState(DEVICE_INFO.isMobile)
  const closeDesktopReminderHandler = () => setIsDeskstopReminderOpen(false)
  return (
    <DesktopReminderModal
      isOpen={isDeskstopReminderOpen}
      onClose={closeDesktopReminderHandler}
      message={message}
      illustration={illustration}
    />
  )
}
